var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHeartOn = function SvgHeartOn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    fill: "none",
    viewBox: "0 0 15 15"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10.054 1.88q-.688.042-1.333.32-.645.279-1.125.73l-.091.072-.121-.102a4 4 0 0 0-.945-.616 4.3 4.3 0 0 0-1.215-.378 3.4 3.4 0 0 0-.557-.022 5 5 0 0 0-.567.037 4 4 0 0 0-2.264 1.141A3.95 3.95 0 0 0 .648 5.655q-.088 1.05.42 2.087.21.403.473.773.263.366.724.861.228.256 2.116 2.088 1.89 1.829 2.01 1.92.48.36 1.11.36t1.11-.36q.12-.09 2.018-1.936l2.125-2.068q.447-.495.71-.86.264-.37.473-.773.378-.75.43-1.538a4.2 4.2 0 0 0-.201-1.567 3.9 3.9 0 0 0-.663-1.23 3.8 3.8 0 0 0-1.047-.931 4 4 0 0 0-1.164-.488 4 4 0 0 0-1.238-.114"
  })));
};
export default SvgHeartOn;